module.exports = __webpack_public_path__ + "img/gif2.3d3bdba5.png";